import {useSelector} from 'react-redux';

import {selectIotDeviceData} from '../state/selectors/iotDevice';

const useIsShowSkipRegistrationButton = () => {
    const iotDevice = useSelector(selectIotDeviceData);
    const {device, holder} = iotDevice || {};
    const {codentify: chargerCodentify, isHolderConnected} = device || {};
    const {codentify: holderCodentify} = holder || {};

    return chargerCodentify && (!isHolderConnected || holderCodentify);
};

export default useIsShowSkipRegistrationButton;
